var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaliation2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 65.5556C54.1138 65.5556 65.5555 54.1139 65.5555 40C65.5555 25.8861 54.1138 14.4444 39.9999 14.4444C25.8859 14.4444 14.4443 25.8861 14.4443 40C14.4443 54.1139 25.8859 65.5556 39.9999 65.5556Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2166 46.2667C56.23 47.9774 55.9013 49.6736 55.25 51.2556C41.3722 54.6222 26.9944 51.6333 24.7055 51.1111C24.0847 49.572 23.7713 47.9262 23.7833 46.2667H23.9055C23.9055 46.2667 40.35 50.2556 56.0055 46.3444L56.2166 46.2667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 51.2556C53.2611 56 48.1945 59.2889 40.0389 59.2889C31.8056 59.2889 26.6722 55.9222 24.7056 51.1111C26.9945 51.6333 41.3721 54.6222 55.25 51.2556Z",
    fill: "#EA5A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2607 39.7459C33.0976 39.7459 34.5867 37.0636 34.5867 33.7548C34.5867 30.4459 33.0976 27.7636 31.2607 27.7636C29.4237 27.7636 27.9346 30.4459 27.9346 33.7548C27.9346 37.0636 29.4237 39.7459 31.2607 39.7459Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7392 39.7499C49.5761 39.7499 51.0653 37.0675 51.0653 33.7587C51.0653 30.4499 49.5761 27.7675 47.7392 27.7675C45.9022 27.7675 44.4131 30.4499 44.4131 33.7587C44.4131 37.0675 45.9022 39.7499 47.7392 39.7499Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6815 45.753C55.6949 47.4601 55.3669 49.1526 54.7169 50.7311C40.8693 54.0904 26.5228 51.108 24.2389 50.5869C23.6194 49.0512 23.3068 47.409 23.3187 45.753H23.4406C23.4406 45.753 39.8493 49.7332 55.4709 45.8306L55.6815 45.753Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7168 50.7311C52.7322 55.4652 47.6766 58.747 39.5388 58.747C31.3233 58.747 26.2012 55.3876 24.2388 50.587C26.5227 51.1081 40.8691 54.0905 54.7168 50.7311Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliation2);
export default __webpack_public_path__ + "static/media/avaliation-2.58d5b0c3afbb7ff4175a356528c09214.svg";
export { ForwardRef as ReactComponent };